import { userLikelyAuthed } from '@netlify/app-auth'
import { Overlay, Pane, toaster } from 'evergreen-ui'
import { useState } from 'react'

import { SESSION_STORAGE_KEY } from '~/helpers/auth'
import { useActions, useStore } from '~/store/hooks'
import { track } from '~/utils/analytics'
import { messageGift } from '~/utils/messages'

export default function HudSheet() {
  const toggles = useStore(state => state.hud.toggles)

  const closeDrawer = useActions(actions => actions.hud.close)
  const postLoginFetch = useActions(actions => actions.hud.postLoginFetch)

  const [didOpen, setDidOpen] = useState(false)

  const handleOpenComplete = () => {
    // messageGift('FULL_VIEWPORT')

    const isLoggedIn = userLikelyAuthed({ storageKeyOverride: SESSION_STORAGE_KEY })
    if (isLoggedIn && !didOpen) {
      postLoginFetch()
      setDidOpen(true)
    }

    track('drawer_toggle_clicked', {
      toggleName: 'drawer_opened',
      placement: 'dock',
    })

    // @ts-ignore
    document.querySelector('.hud-gutter .sidebartab-active[role="tab"]')?.focus()
  }

  const handleCloseComplete = () => {
    closeDrawer()
    toaster.closeAll()
    if (!toggles.loom) {
      setTimeout(() => {
        messageGift('JAMDOCK_VIEWPORT')
      }, 550)
    }
  }

  return (
    <Overlay
      containerProps={{
        zIndex: -1,
      }}
      isShown={toggles.open}
      onEnter={handleOpenComplete}
      onExit={handleCloseComplete}
      preventBodyScrolling
      shouldCloseOnClick
      shouldCloseOnEscapePress={false}
      // width={SHEET_WIDTH_PERCENT}
    >
      <Pane />
    </Overlay>
  )
}
